export default "/img/v11-0-0_fig2.3afaf949c613be01cd17406f4357f801.png";